import { Grid2, Paper, Typography, Button } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import MiTabla from '../../../components/plantilla/tabla/MiTabla';
import CrearEditarTollModal from './modals/CrearEditarTollModal';
import BtnAcciones from '../../../components/plantilla/tabla/BtnAcciones';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { myApi } from '../../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getUSAStates } from '../../../utils/functions';

const Tolls = () => {

    const isNonMobile = useMediaQuery("(min-width:600px)");
    const [dataTolls, setDataTolls] = useState([]);
    const [selectedToll, setSelectedToll] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleOpenModal = (toll = null) => {
        setSelectedToll(toll);
        setIsEditing(!!toll);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setSelectedToll(null);
        setIsEditing(false);
        setModalOpen(false);
    };

    const fetchTolls = async () => {
        try {
            const response = await myApi.get('/tolls/getTolls');
            setDataTolls(response.data.data);
        } catch (error) {
            console.error('Error fetching tolls:', error);
        }
    };

    useEffect(() => {

        fetchTolls();
    }, []);

    const handleEdit = useCallback(async (toll) => {
        handleOpenModal(dataTolls.find(t => t.id === toll.id));
        setIsEditing(true);
        setSelectedToll(toll);
    }, []);

    const columns = [
        {
            field: 'ExitPlazaName', headerName: 'Plaza de Salida',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'City', headerName: 'Ciudad',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'State', headerName: 'Estado',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                let states = getUSAStates();

                if (!params.row.State) return null;

                const state = states.find(
                    s => s.code?.trim().toUpperCase() === params.row.State?.trim().toUpperCase()
                );

                const stateName = state ? state.name : "sin información";

                return `${params.row.State} - ${stateName}`;


            },
        },
        {
            field: 'Latitude', headerName: 'Latitud',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'Longitude', headerName: 'Longitud',
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: 'NotAutorized', headerName: 'Autorizado',
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                if (params.row.NotAutorized === 'A') return <CheckIcon  sx={{ color: 'green' }} />;
                return <CloseIcon  sx={{ color: 'red' }} />;
            },
        },
        {
            field: 'actions',
            headerName: 'Acciones',
            type: 'actions',
            width: 150,
            getActions: (params) => [
                <BtnAcciones
                    icon={<BorderColorIcon />}
                    label="Editar"
                    onClick={() => handleEdit(params.row)}
                />
            ],
        }

    ];


    return (
        <Paper sx={{ p: 2 }}>
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12, md: 8 }}>
                    <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                        Tolls
                    </Typography>
                </Grid2>
                <Grid2 item size={{ xs: 12, md: 4 }}
                    sx={{
                        display: 'flex',
                        justifyContent: isNonMobile ? 'flex-end' : 'start'
                    }}>
                    {/* <Button
                        variant="contained"
                        startIcon={<AddCircleIcon />}
                        onClick={() => handleOpenModal()}
                        sx={{ backgroundColor: 'black', marginBottom: 1 }}
                    >
                        Agregar Tolls
                    </Button> */}
                </Grid2>
                <Grid2 size={12}>
                    <MiTabla
                        columns={columns}
                        data={dataTolls}
                    />
                </Grid2>
                <CrearEditarTollModal
                    open={modalOpen}
                    onClose={handleCloseModal}
                    refresh={fetchTolls}
                    toll={selectedToll}
                    isEditing={isEditing}
                    states={getUSAStates()} 
                />
            </Grid2>
        </Paper>
    )
}

export default Tolls
